export class Tutorial {
    
}